const { Component, render } = wp.element;

import axios from 'axios';
import PerfectScrollbar from 'react-perfect-scrollbar'
import YouTube from 'react-youtube';

import { isset, toHHMMSS, getCoords, YVY_hexToRgbA, YVY_makeid } from "../utils.class.js"

import './youtube-player.view.scss';

const alias = 'YTY-'

class YouTubePlayerFrontend extends Component {

  constructor(props) {
    super(props);

    this.player_id = YVY_makeid(25)

    this.state = {
      youtube_items: [],
      current_video: '',
      current_play_percente: 0,
      current_buffer_percente: 0,
      current_play_status: false,
      hideControls: false,
      isMouseOver: false,
      volume: 100,
      duration: -1,
      is_muted: false,
      show_playlist: true,
      playlist_position: 'right',
      playlist_thumb_per_page: props.options.playlistThumbPP,
      player_height: props.options.playerHeight,
      overlayColor: props.options.overlayColor,
      overlayOpacity: props.options.overlayOpacity,
    }
 
    this.youtube_opts = {
      //height: props.options.playerHeight,
      height: '100%',
      width: '100%',
      playerVars: { 
        // https://developers.google.com/youtube/player_parameters
        autoplay: props.options.autoplay && props.where == 'frontend' ? 1 : 0,
        showinfo: 0,
        controls: 0,
        autohide: 1,
        iv_load_policy: 3,
        wmode: 'opaque',
        rel: 0,
        fs: 0
      }
    }

    this.videoTarget = -1
    this.jumpTo = this.jumpTo.bind(this)
    this.jumpToVolume = this.jumpToVolume.bind(this)
    this.playPauseFunction = this.playPauseFunction.bind(this)
    this.muteUnmute = this.muteUnmute.bind(this)
    this.togglePlaylist = this.togglePlaylist.bind(this)
    this.nextVideo = this.nextVideo.bind(this)
    this.prevVideo = this.prevVideo.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    this.i18n = {
      'play_video': 'Play video',
      'stop_video': 'Stop video',
      'mute': 'Mute video',
      'unmute': 'Unmute video',
      'share': 'Share',
      'open_youtube': 'Open in Youtube',
      'previous': 'Previous Video',
      'forward': 'Next Video',
      'playlist': 'Toogle playlist',
      'fullscreen': 'Toogle fullscreen',
    }

    this.currentPlayThumbRef = React.createRef();
    //console.clear();
  }

  componentDidMount() {
    const self = this

    const { videos } = this.props
    
    self.setState({ 
      youtube_items: videos,
      current_video: videos[0]
    });
  }

  playVideo( video, event )
  {
    this.setState({ 
      current_video: video
    });

    let one_thumb_size = this.state.player_height / this.state.playlist_thumb_per_page;
    this.state.youtube_items.map( (tmp__video, index) => {
      if( tmp__video && tmp__video.etag == video.etag ){
        this._scrollBarRef._container.scrollTop = one_thumb_size * index;
      }
    })
  }

  componentDidUpdate()
  {
    if( this.show_playlist === true ) {
      this._scrollBarRef._container.scrollTop = this.currentPlayThumbRef.offsetTop;
    }
  }

  buildPlaylist( player_height, playlist_thumb_per_page, overlayColor )
  {
    const self = this 
    const { youtube_items, current_video } = this.state

    if( youtube_items.length > 0 ){

      const playlist = youtube_items.map( (video, key) => {

        if( isset(video, 'snippet') ){
          return <li key={ key } onClick={ this.playVideo.bind( this, video ) } ref={ (thumb) => { 

            if( current_video && current_video.etag == video.etag ){
              self.currentPlayThumbRef = thumb
            }

           } } className={ ( current_video && current_video.etag == video.etag ) ? 'videoIsPlaying' : '' }>
            <div className={ alias + "Thumbnails" } style={{ height: player_height / playlist_thumb_per_page, backgroundImage: 'url(' + ( video.snippet.thumbnails.medium.url ) + ')' }}></div>
            <div className={ alias + "Overlay" }>
              <div className={ alias + "Title" }>{ video.snippet.title }</div>
              <div className={ alias + "Channel" }>{ video.snippet.channelTitle }</div>
            </div>

            <div className={ alias + "NowPlaying" } style={ { backgroundColor: overlayColor } }><span className={ "JoeVideoPlayer-icon-play"}></span>Now Playing</div>
          </li>
        }
      })

      return <PerfectScrollbar ref={(container) => { this._scrollBarRef = container; }} ><ul>{playlist}</ul></PerfectScrollbar>
    }
  }

  onYoutubeVideoIsReady(event) 
  {
    this.videoTarget = event.target

    //console.log( this.videoTarget.getCurrentTime() );
    //console.log( this.videoTarget.getDuration() );
    //console.log( this.videoTarget );

    //console.log( "muted" + this.videoTarget.isMuted() );
    //console.log( "getVolume" + this.videoTarget.getVolume() );

    this.setState({ volume: this.videoTarget.getVolume() });

    if( this.videoTarget.isMuted() ){
      this.setState({ volume: -1 });
    }

    let duration = event.target.getDuration()
    this.setState({ duration: toHHMMSS(duration) });
  }

  timer(event, playerTotalTime)
  {
    const player = event.target
    let playerCurrentTime = player.getCurrentTime();
    let playerTimeDifference = ( playerCurrentTime / playerTotalTime ) * 100;

    this.setState({
      'current_play_percente': playerTimeDifference,
      'current_buffer_percente': player.getVideoLoadedFraction() * 100,
    })

    // buffer 
    // this.getVideoLoadedFraction
    // this.videoTarget.getVideoBytesLoaded(), this.videoTarget.getVideoBytesTotal()
  }

  jumpTo(event)
  {
    let currentTargetRect = event.currentTarget.getBoundingClientRect();
    const event_offsetX = event.pageX - currentTargetRect.left;

    let position_as_percent = ( event_offsetX / event.currentTarget.offsetWidth ) * 100;
    this.videoTarget.seekTo(this.videoTarget.getDuration() * position_as_percent / 100 );
  }

  muteUnmute(event)
  {
    if( this.videoTarget.isMuted() ){
      this.videoTarget.unMute();

      this.setState({ is_muted: false });
    }else{
      this.videoTarget.mute();
      this.setState({ is_muted: true });
    }
  }

  togglePlaylist(event)
  {
    event.preventDefault();

    this.setState({ 
      show_playlist: !this.state.show_playlist
    });
  }

  jumpToVolume(event)
  {
    let currentTargetRect = event.currentTarget.getBoundingClientRect();
    const event_offsetX = event.pageX - currentTargetRect.left;

    let position_as_percent = Math.ceil(( event_offsetX / event.currentTarget.offsetWidth ) * 100);
    
    this.videoTarget.setVolume( position_as_percent );
    this.setState({ volume: position_as_percent });
  }

  onStateChange(event)
  {
    //console.log( 'state changed : ' + event.data );

    if( event.data == YT.PlayerState.ENDED ){
      event.preventDefault = () => {}
      this.nextVideo( event );
    }

    let playerTotalTime = event.target.getDuration();
    if ( 
      event.data == YT.PlayerState.PAUSED ||
      event.data == YT.PlayerState.ENDED
    ) {
      clearInterval( this.intervalId );
    }

    if (event.data == YT.PlayerState.PLAYING) {
      this.setState({ current_play_status: true });

      clearInterval( this.intervalId );
      this.intervalId =  setInterval(this.timer.bind(this, event, playerTotalTime), 150);
    }
  }

  playPauseFunction(event)
  {
    let status = this.videoTarget.getPlayerState()
    if ( 
      status == YT.PlayerState.PAUSED ||
      status == YT.PlayerState.CUED
    ){
      this.videoTarget.playVideo();
      this.setState({ current_play_status: true });
    }else{
      this.videoTarget.pauseVideo();
      this.setState({ current_play_status: false });
    }
  }

  toggleFullscreen( event ) 
  {
    event.preventDefault();
    let self = this

    let element = document.getElementById( this.player_id );
    
    let isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

    element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
    document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };

    isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();

    element.classList.toggle("isFullscreen")

    document.addEventListener('fullscreenchange', this.exitHandler );
    document.addEventListener('webkitfullscreenchange', this.exitHandler);
    document.addEventListener('mozfullscreenchange', this.exitHandler);
    document.addEventListener('MSFullscreenChange', this.exitHandler);

    /*let timeout;
    if( this.state.current_play_status === true ){
      document.onmousemove = () => {
        clearTimeout( timeout );

        timeout = setTimeout( function(){
          self.setState({ isMouseOver: false });
        }, 1000); 
      };
    }*/

    self.setState({ isMouseOver: false });
  }

  exitHandler( player ) {
      if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        player.srcElement.classList.remove("isFullscreen");
      }
  }  

  nextVideo( event )
  {
    event.preventDefault();

    let current_index = this.state.youtube_items.findIndex( x => x.etag == this.state.current_video.etag );
    let next_index = current_index + 1;

    if( this.state.youtube_items.length == next_index ){
      next_index = 0;
    }

    this.playVideo( this.state.youtube_items[next_index] )
  }

  prevVideo( event )
  {
    event.preventDefault();

    let current_index = this.state.youtube_items.findIndex( x => x.etag == this.state.current_video.etag );
    let next_index = current_index - 1;

    if( next_index < 0 ){
      next_index = this.state.youtube_items.length - 1;
    }

    this.playVideo( this.state.youtube_items[next_index] )
  }

  onMouseLeave( event )
  {
    this.setState({ isMouseOver: false });
  }

  onMouseEnter( event )
  {
    this.setState({ isMouseOver: true });
  }

  render() {

    let { 
      current_video, 
      current_play_percente, 
      current_buffer_percente, 
      current_play_status, 
      volume, 
      is_muted, 
      duration, 
      show_playlist, 
      playlist_position, 
      overlayColor,
      overlayOpacity,
      player_height,
      player_width,
      playlist_thumb_per_page,
      isMouseOver
    } = this.state

    if( overlayColor != this.props.options.overlayColor ){
      overlayColor = this.props.options.overlayColor;
    }

    if( overlayOpacity != this.props.options.overlayOpacity ){
      overlayOpacity = this.props.options.overlayOpacity;
    }

    if( current_video.id != this.props.videos[0].id && this.props.where != 'frontend' ){
      current_video = this.props.videos[0];
    }

    if( player_width != this.props.options.playlistWidth ){
      player_width = this.props.options.playlistWidth;
    }
    if( player_height != this.props.options.playerHeight ){
      player_height = this.props.options.playerHeight;

      this.youtube_opts.height = player_height;
    }

    if( playlist_thumb_per_page != this.props.options.playlistThumbPP ){
      playlist_thumb_per_page = this.props.options.playlistThumbPP;
    }

    //if( JSON.stringify(this.props.videos) === JSON.stringify(this.state.youtube_items) ){
      this.state.youtube_items = this.props.videos;
    //}

    if( this.state.youtube_items.length == 1 ){
      show_playlist = false;
    }

    return <div className={ alias + "wrapper" + " " + ( !show_playlist ? alias + 'NOPlaylist' : '' ) + " " + alias + "position" + playlist_position } style={{ gridTemplateColumns: '1fr ' + ( player_width ) + 'px', height: player_height + "px" }}>
      <div className={ alias + "MainVideo" } id={ ( this.props.where == "frontend" ? this.player_id : '' ) } onMouseEnter={ this.onMouseEnter } onMouseLeave={ this.onMouseLeave }>
        <div className={ alias + "FullVideo" }>
          { 
            current_video != "" ? 
              <YouTube
                videoId={ current_video.id }
                opts={ this.youtube_opts }
                onReady={ this.onYoutubeVideoIsReady.bind(this) }
                onStateChange={ this.onStateChange.bind(this) }
              />
             : ''
          }
        </div>
        { 
          current_video && (this.videoTarget != -1) != "" ? 

        <div onMouseEnter={ this.onMouseEnter } onMouseLeave={ this.onMouseLeave } className={ alias + "Controls" + " " + ( current_play_status && isMouseOver === false ? "hideControls" : '' ) }>

          <div className={ `${alias}left-col` }>
            <div className={ alias + "ProgressBar" } onClick={this.jumpTo}>
              <div className={ alias + "Buffered" } style={{ width: current_buffer_percente + "%"}}></div>
              <div className={ alias + "Progress" } style={{ width: current_play_percente + "%", backgroundColor: YVY_hexToRgbA(overlayColor, overlayOpacity) }}></div>
            </div>
            
            { current_play_status == false ? 
                <div className={ alias + "Play" } onClick={this.playPauseFunction}><span className={ alias + "Tooltip" }>{this.i18n.play_video}</span></div>
              :
                <div className={ alias + "Pause" } onClick={this.playPauseFunction}><span className={ alias + "Tooltip" }>{this.i18n.stop_video}</span></div>
            }

            <div className={ alias + "Volume" }>
              { is_muted ?
                <div className={ alias + "VolumeMute" } onClick={this.muteUnmute}><span className={ alias + "Tooltip" }>{this.i18n.unmute}</span></div>
                :
                <div className={ alias + "VolumeIcon" } onClick={this.muteUnmute}><span className={ alias + "Tooltip" }>{this.i18n.mute}</span></div>
              }
              <div className={ alias + "VolumeProgressBar" } onClick={this.jumpToVolume}>
              { is_muted === false ?
                  <div className={ alias + "VolumeProgress" } style={{ width: volume + "%", backgroundColor: YVY_hexToRgbA(overlayColor, overlayOpacity)}}></div>
                : ''
              }
              </div>
            </div>

            <div className={ alias + "Timer" }>{ toHHMMSS( this.videoTarget.getCurrentTime() ) }<span>/</span>{ duration != -1 ? duration : '00:00' }</div>
          </div>

          <div className={ `${alias}right-col` }>
            {  
              this.props.options.showShareBtn && 0 ? 
                <a href="#" className={ alias + "Share" }><span className={ alias + "Tooltip" }>{this.i18n.share}</span></a>
              : ''
            }

            {  
              this.props.options.showYouTubeBtn ? 
                <a target="_blank" href={ this.videoTarget.getVideoUrl() } className={ alias + "YouTube" }><span className={ alias + "Tooltip" }>{this.i18n.open_youtube}</span></a>
              : ''
            }

            {  
              this.props.options.showPrevBtn ? 
                <a href="#" className={ alias + "Backward" } onClick={this.prevVideo}><span className={ alias + "Tooltip" }>{this.i18n.previous}</span></a>
              : ''
            }

            {  
              this.props.options.showNextBtn ?
                <a href="#" className={ alias + "Forward" } onClick={this.nextVideo}><span className={ alias + "Tooltip" }>{this.i18n.forward}</span></a>
              : ''
            }

            {  
              this.props.options.showPlaylistBtn ?
                <a href="#" className={ alias + "ShowPlaylist" } onClick={this.togglePlaylist}><span className={ alias + "Tooltip" }>{this.i18n.playlist}</span></a>
              : ''
            }

            {  
              this.props.options.showFullScreenBtn ?
                <a href="#" className={ alias + "FullScreen" } onClick={this.toggleFullscreen}><span className={ alias + "Tooltip" }>{this.i18n.fullscreen}</span></a>
              : ''
            }
          </div>

        </div>
        : ''
      }
      </div>

      { show_playlist ? 
        <div className={ alias + "Playlist" } id={ alias + "Playlist" } style={{ height: player_height + "px" }}>
          { this.buildPlaylist( player_height, playlist_thumb_per_page, overlayColor ) }
        </div>
        : ''
      }
    </div>
  }
}

export { YouTubePlayerFrontend };


// Instantiate for every carousel on page
document.addEventListener("DOMContentLoaded", function (event) {
    var players = document.querySelectorAll('.YTY-wrapper');

    for (var i = 0; i < players.length; i++) {

      var parentElm = players[i].parentNode;
      let videos = JSON.parse( parentElm.getAttribute('data-videos') ),
          options = JSON.parse( parentElm.getAttribute('data-options') );

      render(
        <YouTubePlayerFrontend videos={ videos } options={ options } where="frontend" />, 
        parentElm
      );
      console.log("%c players present on page and running...", "color: #9C27B0");
    }
});


// WEBPACK FOOTER //
// ./src/youtube-player/youtube-player.view.js